<template>
  <div class="default-val-input">
    <div class="setting">
      <template v-if="'staff' === curControl._type">
        <select-scope
          title="选择人员"
          :multiple="!curControl.oneFlag"
          :var-group="canUseVars"
          :show-department-tab="false"
          show-user-tab
          v-model="res.value"
        ></select-scope>
      </template>
      <template v-else-if="'department' === curControl._type">
        <div>
          <el-radio-group v-model="res.type" @change="setDepartmentLevel">
            <el-radio label="var">变量</el-radio>
            <el-radio label="user">关联人员</el-radio>
          </el-radio-group>
        </div>
        <select-scope
          v-if="res.type === 'var'"
          title="选择部门"
          :multiple="!curControl.oneFlag"
          :var-group="canUseVars"
          :show-user-tab="false"
          show-department-tab
          v-model="res.value"
        ></select-scope>
        <template v-else-if="res.type === 'user'">
          <el-select v-model="res.relatedCid" class="user-select">
            <el-option
              v-for="control in (sheet.controls || []).filter(ctl => ctl._type === 'staff')"
              :key="control._cid"
              :label="control.name"
              :value="control._cid"
            ></el-option>
          </el-select>
          <el-select v-model="res.departmentLevel" class="department-select">
            <el-option
              v-for="control in departmentLevels"
              :key="control.value"
              :label="control.label"
              :value="control.value"
            ></el-option>
          </el-select>
        </template>
      </template>
      <template v-else-if="'company' === curControl._type">
        <select-scope
          title="选择企业"
          :multiple="!curControl.oneFlag"
          :var-group="canUseVars"
          :show-user-tab="false"
          :show-department-tab="false"
          :additional-tabs="additionalTabs"
          v-model="res.value"
        ></select-scope>
      </template>
      <template v-else-if="['address', 'area', 'date', 'time'].includes(curControl._type)">
        <set-value
          ref="setValue"
          :key="curControl._cid"
          :value="res"
          :type="curControl._type"
          :curControl="curControl"
          :data-list="canUseVars"
        ></set-value>
      </template>
      <template v-else-if="['string', 'select'].includes(curControl._dataType)">
        <textarea-editor
          :value="res"
          @input="Object.assign(res, $event)"
          :var-group="canUseVars"
        ></textarea-editor>
      </template>
      <template v-else-if="curControl._dataType == 'number'">
        <textarea-editor
          :value="res"
          @input="Object.assign(res, $event)"
          :var-group="canUseVars"
          output-text-type="normal"
          style="background: white;"
        ></textarea-editor>
      </template>
      <template v-else>
        尚未配置
      </template>
    </div>
  </div>
</template>

<script>
import SelectScope from "@/components/UIComponents/SelectScope"
import SetValue from "./SetValue-sheetEdit"
import { decorateSheet, getCanUseType } from "@/utils/sheet"
import { getAllConnectedCompany } from "@/api/connect"
import TextareaEditor from "@/components/UIComponents/TextareaEditor"
import {
  addressLevel,
  departmentLevels
} from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/static"

export default {
  name: "default-val-input",
  components: {
    TextareaEditor,
    SelectScope,
    SetValue
  },
  props: {
    curControl: {
      type: Object
    },
    sheet: {
      type: Object
    },
    value: {
      type: Object,
      required: true
    },
    availableSheetMap: {
      type: Object
    }
  },
  data() {
    return {
      addressLevel,
      departmentLevels,
      res: {},
      connectedCompanies: []
    }
  },
  watch: {
    res: {
      handler() {
        if ("department" === this.curControl._type) {
          if (!this.res.type) this.$set(this.res, "type", "var")
          if (this.res.type === "user") {
            // 部门字段如果设置了依赖于某个人员字段,则自动设置"可编辑,多选,不必填",且隐藏这些属性
            this.curControl.disabled = false
            this.curControl.oneFlag = false
            this.curControl.required = false
            this.curControl._hideAttrs = ["disabled", "oneFlag", "required"]
          } else {
            this.curControl._hideAttrs = []
          }
        }
      },
      deep: true
    },
    curControl: {
      handler(newControl, oldControl) {
        if (newControl._cid !== oldControl?._cid) {
          this.res = this.value
          if (["staff", "department", "company"].includes(this.curControl._type)) {
            this.$set(this.res, "value", this.value.value || [])
          }
          if (
            this.curControl._type === "department" &&
            this.res?.type === "user" &&
            !this.res?.departmentLevel
          ) {
            this.setDepartmentLevel("user")
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    canUseVars() {
      let canUseType = getCanUseType(this.curControl._type)
      let varGroup = [this.getVars(this.sheet, canUseType)]
      if (this.curControl._type === "staff") {
        varGroup[0]?.options?.push({
          label: "创建人",
          type: "staff",
          value: "vCurrentUser"
        })
      }
      let refCanUseType = []
      if (this.curControl._type === "number") {
        refCanUseType = canUseType.concat(["gather", "calc"]) // 关联表的计算控件没有循环更新的问题，允许设置
      } else {
        refCanUseType = canUseType
      }
      decorateSheet(this.sheet)
        .controls.filter(control => control._type === "ref" && control.oneFlag && control._cid)
        .forEach(refControl => {
          if (this.availableSheetMap[refControl.refSheetId])
            varGroup.push(
              this.getVars(this.availableSheetMap[refControl.refSheetId], refCanUseType, refControl)
            )
        })
      return varGroup.filter(i => i.options.length != 0)
    },
    additionalTabs() {
      if (this.curControl._type == "company") {
        return [
          {
            label: "企业",
            value: "company",
            options: this.connectedCompanies.map(({ id, name }) => ({ id, name }))
          }
        ]
      }
      return []
    }
  },
  created() {
    if (this.curControl._type == "company") {
      getAllConnectedCompany().then(companies => (this.connectedCompanies = companies))
    }
  },
  methods: {
    getVars(sheetDef, canUseType, refControl) {
      let vars = [],
        title = ""
      if (!refControl) title = "自己"
      else title = refControl.name
      decorateSheet(sheetDef).controls.forEach(control => {
        // 跳过自身和新建的字段
        if (control._cid === this.curControl._cid || !control._cid) return
        if (canUseType.includes(control._type)) {
          let v = control._cid
          let name = control.name
          if (refControl) v = refControl._cid + "_" + v
          vars.push({
            label: `[${title}] ${name}`,
            type: control._type,
            value: "v" + v
          })
        }
      })
      return { title, label: title, options: vars }
    },
    resetRes() {
      this.res = this.$refs.setValue.getDefaultVal()
      return this.res
    },
    setDepartmentLevel(val) {
      this.$set(this.res, "departmentLevel", val === "user" ? 3 : null)
    }
  }
}
</script>

<style lang="scss" scoped>
.default-val-input {
  .setting {
    flex: auto;
    .user-select {
      width: 100%;
      margin-bottom: 10px;
    }
    .department-select {
      width: 100%;
    }
    ::v-deep {
      .el-input .el-input__inner {
        height: unset;
        line-height: unset;
      }
    }
  }
  .tip {
    min-width: 30px;
  }
  .textarea-container {
    margin-top: 0;
  }
}
</style>
